import { render } from "./ApprovalsList.vue?vue&type=template&id=6d13995e"
import script from "./ApprovalsList.vue?vue&type=script&lang=js"
export * from "./ApprovalsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__